// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Dealer } from './dealer';
import { Invoice } from './invoice';
import { InvoiceFee } from './invoice-fee';
import { InvoiceStatus } from './invoice-status';
import { OrderLineDetail } from './order-line-detail';
import { PaymentLine } from './payment-line';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags
import { PaymentLineType } from './payment-line-type';
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PackingSlip extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get totalCalc() {
        let subTotal = 0;
        if (!!this.orderLineDetails) {
            this.orderLineDetails.forEach((detail) => {
                if (!detail.deleted && !detail.orderLine.deleted) subTotal += detail.quantity * detail.orderLine.price;
            });
        }
        return subTotal + this.freight + this.tax + this.feesTotal - this.paymentsTotal;
    }

    get invoiceTotal() {
        return this.subTotal + this.freight + this.tax + this.feesTotal;
    }

    get invoiceBalance() {
        return this.subTotal + this.freight + this.tax + this.feesTotal - this.paymentsTotal;
    }

    get subTotal() {
        let subTotal = 0;
        if (!!this.orderLineDetails) {
            this.orderLineDetails.forEach((detail) => {
                if (!detail.deleted && !detail.orderLine.deleted) subTotal += detail.quantity * detail.price;
            });
        }
        return subTotal;
    }

    get feesTotal() {
        let subTotal = 0;
        subTotal = _.sumBy(this.invoiceFees.filter(x => !x.deleted), 'amount');

        return subTotal;
    }

    get paymentsTotal() {
        let paymentTotal = 0;
        if (!!this.orderLineDetails) {
            this.orderLineDetails.forEach((detail) => {
                if (detail.paymentLines.length > 0) {
                    detail.paymentLines
                        .filter((line) => line.deleted === null)
                        .forEach((paymentLine) => {
                            paymentTotal += paymentLine.amount;
                        });
                }
            });
        }
        if(!!this.invoiceFees) {
            this.invoiceFees.forEach(fee => {
                if (fee.paymentLines) {
                    paymentTotal += _.sumBy(fee.paymentLines.filter(x => !x.deleted), 'amount')
                }
            })
        }
        if (!!this.paymentLines) {
            this.paymentLines
                .filter((line) => line.amount > 0 && line.deleted === null && !line.orderLineDetailId && line.paymentLineTypeId !== PaymentLineType.Types.NorthPointFee)
                .forEach((line) => {
                    paymentTotal += line.amount;
                });
        }
        return paymentTotal;
    }

    get ordersList() {
        const orderList = [];
        if (!!this.orderLineDetails && this.orderLineDetails.length > 0) {
            this.orderLineDetails.forEach((detail) => {
                if (!_.includes(orderList, detail.orderLine.order.invoiceNumber)) orderList.push(detail.orderLine.order.invoiceNumber);
            });
        }
        return orderList;
    }

    get ordersListString() {
        let orderList = this.ordersList;
        return orderList.join(" ");
    }

    get orderIdsList() {
        const list = [];
        if (!!this.orderLineDetails && this.orderLineDetails.length > 0) {
            this.orderLineDetails.forEach((detail) => {
                if (!_.includes(list, detail.orderLine.orderId)) list.push(detail.orderLine.orderId);
            });
        }
        return list;
    }

    get statusDisplay() {
        let status = '';
        const statusList = [];
        if (!!this.orderLineDetails && this.orderLineDetails.length > 0) {
            this.orderLineDetails.forEach((detail) => {
                if (!_.includes(statusList, detail.status.name)) statusList.push(detail.status.name);
            });
            statusList.forEach((statusName) => {
                status += statusName + '; ';
            });
        }
        return status;
    }

    get canExport() {
        let allComplete = true;
        if (!this.orderLineDetails || this.orderLineDetails.length === 0) return false;
        this.orderLineDetails.forEach((detail) => {
            if (detail.status.name !== 'Complete') allComplete = false;
        });
        return allComplete;
    }

    get invoiceShipInfo() {
        let shipInfo = {};
        const order = this.orderLineDetails[0].orderLine.order;
        return (shipInfo = {
            shipAddressId: order.shipAddressId,
            shipToContactName: order.shipToContactName,
            shipToLocation: order.shipToLocation,
            shipToAddress1: order.shipToAddress1,
            shipToAddress2: order.shipToAddress2,
            shipToCity: order.shipToCity,
            shipToState: order.shipToState,
            shipToZip: order.shipToZip,
            shipToCountry: order.shipToCountry,
            shipToPhone: order.shipToPhone,
            shipToEmail: order.shipToEmail,
            shippingNote: order.shippingNote,
        });
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  createDate?: Date;
  createdById?: number;
  dealerId?: number;
  deleted?: Date;
  deletedBy?: string;
  deliveryMethod?: string;
  emailed?: Date;
  freight!: number;
  freightInvoiceId?: number;
  invoiceNumber!: number;
  invoiceStatusId?: number;
  markedReadyById?: number;
  note?: string;
  packingSlipNumber?: number;
  paid?: Date;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  quickBooksOnlineId?: string;
  quickBooksOnlineLastExport?: Date;
  readyToExport?: Date;
  reportGuid?: string;
  tax!: number;
  total!: number;
  createdBy!: User;
  dealer!: Dealer;
  freightInvoice!: Invoice;
  invoiceFees!: InvoiceFee[];
  invoiceStatus!: InvoiceStatus;
  markedReadyBy!: User;
  orderLineDetails!: OrderLineDetail[];
  paymentLines!: PaymentLine[];
}

